import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Popover,
  OverlayTrigger
} from 'react-bootstrap';


class HelperPopover extends Component {
  render() {
    return (
      <OverlayTrigger
        trigger={['hover', 'focus']}
        placement="left"
        shouldUpdatePosition={true}
        overlay={
          <Popover id='popover-of-form'>
            <div className="help-operators">
              <p>Help operators:</p>
              <table>
                <tbody>
                <tr title="Find all words, e.g.: motion AND 363">
                  <td>AND</td><td>All Words</td>
                </tr>
                <tr title="Find at least one of the words, e.g.: motion OR 363">
                  <td>OR</td><td>Either Word</td>
                </tr>
                <tr title="Find these words within n words of each other, e.g.: motion /3 363">
                  <td>/n</td><td>Within <var>n</var> terms of</td>
                </tr>
                <tr title="Find this sequence of words exactly as typed, e.g.: &quot;order on motion for relief from stay&quot;">
                  <td>"_"</td><td>Phrase</td>
                </tr>
                <tr title="Find results without this word, e.g.: order -relief">
                  <td>-word</td><td>But not</td>
                </tr>
                <tr title="Find words that start or end as specified, e.g.: evid*">
                  <td>*</td><td>Wildcard</td>
                </tr>
                </tbody>
              </table>
            </div>
          </Popover>
        }>
        {this.props.children}
      </OverlayTrigger>
    )
  }
}

HelperPopover.defaultProps = {
  children: null,
};

HelperPopover.propTypes = {
  children: PropTypes.any
  //   .oneOfType([
  //   PropTypes.array,
  //   PropTypes.element,
  // ]),
};


export default HelperPopover;



// WEBPACK FOOTER //
// ./src/components/advancedSearch/HelperPopover.js